// ITER288 — Shared QR dialog. Extracted from AdminOutletMenus so it can
// be reused by ManagerMenuAvailability (and any future menu-adjacent
// share surface). Purely presentational — the caller passes the QR
// payload already fetched from either the admin or the manager endpoint.
import React from 'react';
import { Eye, Download, Printer } from 'lucide-react';
import {
  Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription,
} from '../ui/dialog';
import { Button } from '../ui/button';

const PRIMARY = 'var(--color-primary)';
const SECONDARY = '#8B7355';
const CREAM = '#FFF6E7';

export function QrDialog({ open, onClose, data, outletName }) {
  const printTent = () => {
    const w = window.open('', '_blank');
    if (!w || !data) return;
    w.document.write(`<!doctype html><html><head><title>QR — ${outletName || ''}</title>
      <style>
        @page { size: A4 portrait; margin: 20mm; }
        body { font-family: Georgia, serif; text-align: center; color: ${PRIMARY}; }
        .card { border: 2px solid ${SECONDARY}; border-radius: 20px; padding: 40px 30px;
                max-width: 480px; margin: 0 auto; background: ${CREAM}; }
        h1 { font-size: 28px; margin: 8px 0 0; }
        .sub { font-size: 14px; color: #555; margin-top: 4px; letter-spacing: 2px; text-transform: uppercase; }
        .cta { font-size: 20px; margin: 26px 0 14px; letter-spacing: 1px; }
        img { width: 260px; height: 260px; }
        .url { font-family: monospace; font-size: 12px; color: #666; margin-top: 20px; word-break: break-all; }
      </style></head><body onload="window.print()">
      <div class="card">
        <div class="sub">Digital Menu</div>
        <h1>${outletName || ''}</h1>
        <div class="cta">Scan to View Menu</div>
        <img src="${data.qr_png_data_url}" alt="QR" />
        <div class="url">${data.url}</div>
      </div>
      </body></html>`);
    w.document.close();
  };

  const downloadQr = () => {
    if (!data) return;
    const a = document.createElement('a');
    a.href = data.qr_png_data_url;
    a.download = `menu-qr-${data.slug}.png`;
    a.click();
  };

  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="qr-dialog">
        <DialogHeader>
          <DialogTitle style={{ color: PRIMARY }}>Menu QR Code</DialogTitle>
          <DialogDescription>
            One QR per outlet — prints on table tents and always shows your latest menus.
          </DialogDescription>
        </DialogHeader>
        {!data ? (
          <div className="p-6 text-center text-gray-400">Loading…</div>
        ) : (
          <div className="space-y-4">
            <div className="p-6 rounded-xl border-2 flex flex-col items-center gap-3"
                 style={{ borderColor: SECONDARY, background: CREAM }}>
              <div className="text-xs uppercase tracking-widest" style={{ color: PRIMARY }}>
                Scan to View Menu
              </div>
              <div className="font-serif text-lg" style={{ color: PRIMARY }}>
                {outletName}
              </div>
              <img src={data.qr_png_data_url} alt="QR" className="w-56 h-56"
                   data-testid="qr-image" />
              <div className="text-[11px] font-mono text-gray-500 break-all text-center">
                {data.url}
              </div>
            </div>
            <div className="flex flex-wrap gap-2 justify-center">
              <a href={data.url} target="_blank" rel="noreferrer">
                <Button variant="outline">
                  <Eye className="w-4 h-4 mr-1" />View Menu
                </Button>
              </a>
              <Button variant="outline" onClick={downloadQr} data-testid="qr-download-btn">
                <Download className="w-4 h-4 mr-1" />Download QR
              </Button>
              <Button style={{ background: PRIMARY, color: '#fff' }} onClick={printTent}
                      data-testid="qr-print-btn">
                <Printer className="w-4 h-4 mr-1" />Print Tent
              </Button>
            </div>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default QrDialog;
